import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { PageError } from "src/common/components";
import Routes from "src/common/Routes";
import { IAppReduxState, IExtendedUser, IUserRole } from "src/common/types";
import { LocalesContext } from "src/common/contexts";
import { UserRoles } from "src/common/types/roles";

interface IStateProps {
  userRole: IUserRole;
}

type Props = IStateProps;

const CyclesView = ({ userRole }: Props) => {
  const { t } = useTranslation();
  const { locales } = React.useContext(LocalesContext);
  const availableLocales = locales.join("|");

  switch (userRole) {
    case UserRoles.CountryAdmin:
      return (
        <Switch>
          <Route exact path={`/:lng(${availableLocales})/dashboard/:view(cycles)`} component={Routes.CyclesList} />
          <Route
            exact
            path={`/:lng(${availableLocales})/dashboard/:view(cycles)/:cycleId/participants`}
            component={Routes.CycleParticipantsPage}
          />
          <Route render={() => <PageError message={t(`feedback.pageNotFound`)} />} />
        </Switch>
      );
    case UserRoles.SuperAdmin:
      return (
        <Switch>
          <Route exact path={`/:lng(${availableLocales})/dashboard/cycles`} component={Routes.CyclesList} />
          <Route
            exact
            path={`/:lng(${availableLocales})/dashboard/:view(cycles)/:cycleId/participants`}
            component={Routes.CycleParticipantsPage}
          />
          <Route
            exact
            path={`/:lng(${availableLocales})/dashboard/:view(cycles)/upload`}
            component={Routes.UploadParticipants}
          />
          <Route
            exact
            path={`/:lng(${availableLocales})/dashboard/:view(cycles)/create`}
            component={Routes.CreateCycle}
          />
          <Route
            exact
            path={`/:lng(${availableLocales})/dashboard/:view(cycles)/update/:cycleId`}
            component={Routes.CreateCycle}
          />
        </Switch>
      );
    default:
      return <PageError message={t(`feedback.pageNotFound`)} />;
  }
};

const mapStateToProps = ({ currentUser: { userData } }: IAppReduxState) => ({
  userRole: (userData as IExtendedUser).userRole as IUserRole
});

export default connect(mapStateToProps, null)(React.memo(CyclesView));
